import { render, staticRenderFns } from "./PageSwitcher.vue?vue&type=template&id=04d12f77&"
import script from "./PageSwitcher.vue?vue&type=script&lang=js&"
export * from "./PageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PageSwitcher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSnackbar,VTab,VTabs})
